import * as _ from 'lodash';

export default function isEmpty(value: any): boolean {
  if (typeof value === 'boolean' || typeof value === 'number' || value instanceof Date) {
    return false;
  }
  return value === '' || value === null || value === undefined || _.isEmpty(value) || _.size(value) === 0;
}
